import { GlobalAppData } from "../models/global-app-data";
import { LoadingService } from "../services/loading.service";
import { SharedService } from "../services/shared.service";

export const getQueryParamByName = (name: string, url?: string) => {
    if (!url) {
        url = (window as any).location.href;
    }

    name = escapeRegex(name);
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) { return ''; }
    return decodeURIComponent(results[2]);
};

export const updateQueryStringParam = (key: string, value: string) => {
    const baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
    const urlQueryString = document.location.search;
    const newParam = key + '=' + value;
    let params = '?' + newParam;
    if (urlQueryString) {

        const safeKey = escapeRegex(key);
        const keyRegex = new RegExp('([?&])' + safeKey + '[^&]*');
        //   If param exists already, update it
        if (urlQueryString.match(keyRegex) !== null) {
            params = urlQueryString.replace(keyRegex, '$1' + newParam);
        } else { //  Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam;
        }
    }
    window.history.replaceState({}, '', baseUrl + params);
};

function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const htmlToString =(html) =>{
  var temporalDivElement = document.createElement("div");
  temporalDivElement.innerHTML = html;
  return temporalDivElement.textContent.replace(/\s\s+/g, ' ') || temporalDivElement.innerText.replace(/\s\s+/g, ' ') || "";
};

export const loadExternalJavascript = (scriptSrc: string) => {
    const loadScript = document.createElement('script');
    loadScript.src = scriptSrc;
    loadScript.async = true;
    loadScript.type = 'text/javascript';
    window.document.head.appendChild(loadScript);
}

export const loadGtmNoscript = (gtmId: string) => {
    const addGtmIframe = document.createElement('iframe');
    addGtmIframe.src = 'https://www.googletagmanager.com/ns.html?id=' + gtmId;
    addGtmIframe.setAttribute('style', 'display:none;visibility:hidden');
    addGtmIframe.height = '0';
    addGtmIframe.width = '0';
    const noscriptAtt = document.createElement('noscript');
    noscriptAtt.append(addGtmIframe);
    window.document.body.prepend(noscriptAtt);
}

export const fetchNewtrnsctnAtmptPayByBank = (
  sharedService: SharedService,
  gd: GlobalAppData,
  _loading: LoadingService
): Promise<void> => {
  return sharedService.getNewTransactionId(gd.transId)
    .then((res: string | undefined) => {
      if (res !== undefined) {
        gd.transId = res;
        gd.attemptCount++;
        sessionStorage.setItem('transId', res);  // ← REPLACE updateQueryStringParam('t', res)
      } else {
        console.debug('No transaction ID returned');
      }
    })
    .catch((error) => {
      if (error && error.status && error.error) {
        console.debug(`error ap new txn attempt ${error?.error}`);
      }
    });
};
